import DOMPurify from 'dompurify'
import type { GenerationItem } from '../data/account'

export const TELEGRAM_BOT_ID = '8464718685'
export const TELEGRAM_RETURN_TO = 'https://umnik.ai/auth/telegram-link-callback'

export function formatDate(iso: string) {
	const d = new Date(iso)
	return d.toLocaleDateString('ru-RU', {
		day: '2-digit',
		month: 'short',
		year: 'numeric',
	})
}

// Компактная дата «2 авг» (в этом году) / «15 дек 24» — для плотных списков
// (лоты). Убираем точки и « г.», чтобы не занимало лишнего в узкой ячейке.
export function formatShortDate(iso: string) {
	const d = new Date(iso)
	if (Number.isNaN(d.getTime())) return ''
	const sameYear = d.getFullYear() === new Date().getFullYear()
	return d
		.toLocaleDateString('ru-RU', {
			day: 'numeric',
			month: 'short',
			...(sameYear ? {} : { year: '2-digit' }),
		})
		.replace(/\sг\./g, '')
		.replace(/\./g, '')
		.trim()
}

export function formatDateTime(iso: string) {
	const d = new Date(iso)
	return (
			d.toLocaleDateString('ru-RU', {
				day: '2-digit',
				month: 'short',
			}) +
			' ' +
			d.toLocaleTimeString('ru-RU', {
				hour: '2-digit',
				minute: '2-digit',
			})
	)
}

export function getErrorMessage(error: unknown, fallback = 'Произошла ошибка') {
	if (error instanceof Error && error.message) return error.message

	if (typeof error === 'object' && error !== null && 'message' in error) {
		const message = (error as { message?: unknown }).message
		if (typeof message === 'string' && message.trim()) return message
	}

	return fallback
}

export function redirectToTelegramAuth() {
	const origin = encodeURIComponent('https://umnik.ai')
	const returnTo = encodeURIComponent('https://umnik.ai/auth/telegram-link-callback')

	window.location.href =
			`https://oauth.telegram.org/auth?bot_id=${TELEGRAM_BOT_ID}` +
			`&origin=${origin}&embed=0&request_access=write&return_to=${returnTo}`
}

export function getGenerationThumbUrl(g: GenerationItem) {
	return g.public_url || g.result_url || (g.result_urls && g.result_urls[0]) || null
}

export function getTariffDescriptionLines(description: string | null | undefined) {
	if (!description) return []

	return description
	.split('\n')
	.map((line) => line.replace(/^[—-]\s*/, '').trim())
	.filter(Boolean)
}

export function sanitizeTariffHtml(html: string) {
	return DOMPurify.sanitize(html, {
		ALLOWED_TAGS: ['span', 'strong', 'b', 'em', 'i', 'br', 'ul', 'ol', 'li', 'p'],
		ALLOWED_ATTR: ['class'],
		FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed'],
		FORBID_ATTR: [
			'style',
			'onerror',
			'onload',
			'onclick',
			'onmouseover',
			'onfocus',
			'onmouseenter',
			'onmouseleave',
		],
	})
}